import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsAscIcon} from '../icon/svg/arrows-asc-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ArrowsDescIcon} from '../icon/svg/arrows-desc-icon';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from '../icon/svg/upgrade-arrow-icon';

import {Popover} from './popover';
import type {LocationEnum} from './popover';

import styles from './popover-sort.module.css';

export type Direction = 'ascending' | 'descending';

type FieldOptions = {
    id: string;
    label: string;
};

type Props = {
    activeSort: {
        field: string;
        direction?: Direction;
    };
    fields: FieldOptions[];
    onChangeSort: (sortField: string) => any;
    footerRow?: {
        label: string;
        icon: React.ReactNode;
        onClick: () => void;
        requiresUpgrade?: boolean;
    };
    onClose: () => void;
    location: LocationEnum;
    anchor: HTMLElement | null | undefined;
};

export function PopoverSort(props: Props) {
    return (
        <Popover
            anchor={props.anchor}
            location={props.location}
            onBlur={props.onClose}
            customStyles={{marginLeft: -2, marginTop: 2}}
            noDefaultStyling={true}
        >
            <ul className={styles['popover-sort-container']}>
                {props.fields.map((field) => (
                    <SortItem
                        key={field.id}
                        activeDirection={
                            props.activeSort.field === field.id ? props.activeSort.direction : null
                        }
                        onClick={props.onChangeSort}
                        field={field}
                    />
                ))}
                {props.footerRow ? (
                    <div
                        onClick={props.footerRow.onClick}
                        className={
                            props.footerRow.requiresUpgrade
                                ? styles['footer-button--upgrade']
                                : styles['footer-button']
                        }
                    >
                        <div className='flex align-center'>
                            <div className='mr-8'>{props.footerRow.icon}</div>
                            {props.footerRow.label}
                        </div>
                        {props.footerRow.requiresUpgrade ? (
                            <UpgradeArrowIcon size={15} alignCenter={true} color={colors.blue} />
                        ) : undefined}
                    </div>
                ) : null}
            </ul>
        </Popover>
    );
}

function SortItem(props: {
    activeDirection: Direction | null | undefined;
    onClick: (sortField: string) => any;
    field: FieldOptions;
}) {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    }, []);

    return (
        <li
            data-tip={getTooltip(props.field.label, props.activeDirection)}
            data-place='left'
            onClick={() => props.onClick(props.field.id)}
            className={classnames('justify-sb', styles['row-item'])}
        >
            {props.field.label}
            {props.activeDirection && (
                <span className='flex'>
                    <ArrowsDescIcon
                        size={15}
                        wrapWithDiv={false}
                        fill={
                            props.activeDirection === 'descending' ? colors.blue : colors.offWhiteDk
                        }
                    />
                    <ArrowsAscIcon
                        size={15}
                        wrapWithDiv={false}
                        fill={
                            props.activeDirection === 'ascending' ? colors.blue : colors.offWhiteDk
                        }
                    />
                </span>
            )}
        </li>
    );
}

function getTooltip(label: string, activeDirection?: Direction | null) {
    if (activeDirection === 'ascending' || !activeDirection) {
        return `Sort by ${label} (descending)`;
    }

    return `Sort by ${label} (ascending)`;
}
